import React from 'react';
import logo from '../assets/logo.svg';
import styles from '../pages/Login/Login.module.css';

export default function Logo() {
  return (
    <div className={styles.loginLogoWrap}>
      <img src={logo} alt="Supported Business" className={styles.loginLogo} />
    </div>
  );
} 